import { Card, SectionHeader } from "@dash/page";
import { useTheme } from "@emotion/react";
import { Link } from "react-router-dom-v5-compat";

export type SectionCardProps = {
  header: string;
  linkTo: string;
  linkLabel: string;
  linkIcon: React.ReactNode;
  children?: React.ReactNode;
};

export const SectionCard: React.FC<SectionCardProps> = ({ header, linkTo, linkLabel, linkIcon, children }) => {
  const theme = useTheme();

  return (
    <Card variant="secondary" color={theme.colors.primary} css={{ width: "100%", minWidth: 0 }}>
      <SectionHeader
        css={{ margin: 0, h2: { fontSize: "1rem" } }}
        actions={
          <Link
            to={linkTo}
            css={{
              display: "flex",
              alignItems: "center",
              gap: "0.25rem",
              fontSize: "0.75rem",
              color: theme.colors.primary,
              textDecoration: "none",
              opacity: 0.65,
              whiteSpace: "nowrap",
              "&:hover": { opacity: 1 },
            }}
          >
            {linkIcon}
            {linkLabel}
          </Link>
        }
      >
        {header}
      </SectionHeader>

      {children}
    </Card>
  );
};
